import {
  ADD_HIERARCHY,
  REFRESH_CUSTOMER_ASSETS,
  SELECT_ASSET,
  ADD_COUNTRIES,
  ADD_REGIONS,
  ADD_FACILITIES,
  ADD_FROM_RELATION,
  ADD_CUSTOMERID,
} from '../actions/constants'

const initialState = {
  assetType: 'ROOM',
  hierarchyType: [],
  fromRelation: 'Egypt',
  refreshAssetList: false,
  country: '',
  region: '',
  facility: '',
  customer: '',
}

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_HIERARCHY:
      return {
        ...state,
        hierarchyType: action.payload,
      }
    case ADD_CUSTOMERID:
      return {
        ...state,
        customer: action.payload,
      }
    case ADD_COUNTRIES:
      return {
        ...state,
        country: action.payload,
      }
    case ADD_REGIONS:
      return {
        ...state,
        region: action.payload,
      }
    case ADD_FACILITIES:
      return {
        ...state,
        facility: action.payload,
      }
    case SELECT_ASSET:
      return {
        ...state,
        assetType: action.payload,
      }
    case REFRESH_CUSTOMER_ASSETS:
      return {
        ...state,
        refreshAssetList: action.payload,
      }
    case ADD_FROM_RELATION:
      return {
        ...state,
        fromRelation: action.payload,
      }
    default:
      return {
        ...state,
      }
  }
}
